const HTML_TEMPLATE =
{
  type: "html",
  data: {
    html: `<p style="visibility: visible;text-align: center;">Html block</p>`,
  },

};

export default HTML_TEMPLATE;

